import React, { useEffect, useState } from "react";
import {
    Modal,
} from "antd";
import { showNotification, updateNotification } from '@mantine/notifications';
import { IconX } from '@tabler/icons-react';
import { IconCheck } from '@tabler/icons-react';
import { Select, Flex, NumberInput, Textarea } from '@mantine/core';
import { DateInput } from '@mantine/dates';
import 'dayjs/locale/tr';
import dayjs from 'dayjs';
import Loader from "../atoms/Loader";
import styled from "styled-components";
import CustomButton from "../atoms/Button";
const axios = require("axios").default;

const parseEmails = (raw) => {
    return (raw || "")
        .split(",")
        .map((e) => e.trim())
        .filter((e) => e.length > 0);
};

const BulkAddPackage = ({ isBulkModalVisible, setIsBulkModalVisible, getUserList }) => {

    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [plans, setPlans] = useState([]);
    const [selectedDate, setSelectedDate] = useState("");
    const [subscriptionPlan, setSubscriptionPlan] = useState("");
    const [price, setPrice] = useState("");
    const [emailsRaw, setEmailsRaw] = useState("");
    const [result, setResult] = useState(null);
    dayjs.locale('tr');

    const resetForm = () => {
        setSubscriptionPlan("");
        setSelectedDate("");
        setPrice("");
        setEmailsRaw("");
        setResult(null);
    };

    const handleCancel = () => {
        setIsBulkModalVisible(false);
        resetForm();
    };

    const getPlans = () => {
        setLoading(true);
        axios.get(`student/packets`)
            .then(function (response) {
                setPlans(response?.data?.data);
                return response;
            })
            .catch(function (error) {
                console.log(error)
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        if (isBulkModalVisible) {
            getPlans();
            resetForm();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isBulkModalVisible]);

    const formatDataForSelect = (plans) => {
        return plans?.map(item => ({
            value: item?.id?.toString(),
            label: `${item?.monthly} ay ${item?.numberLesson} kez`
        }));
    };
    const options = formatDataForSelect(plans);

    const handleDateChange = (date) => {
        setSelectedDate(date ? dayjs(date) : null);
    };

    const handleSaveClick = () => {
        const emails = parseEmails(emailsRaw);

        if (!subscriptionPlan) {
            showNotification({
                id: 'bulk-hello-there',
                disallowClose: true,
                autoClose: 5000,
                title: "Please Make Your Choice",
                color: 'red',
                icon: <IconX size="1rem" />,
                style: { backgroundColor: 'white' },
            });
            return;
        }
        if (!price) {
            showNotification({
                id: 'bulk-hello-there',
                disallowClose: true,
                autoClose: 5000,
                title: "Please Enter Price Information",
                color: 'red',
                icon: <IconX size="1rem" />,
                style: { backgroundColor: 'white' },
            });
            return;
        }
        if (!selectedDate) {
            showNotification({
                id: 'bulk-hello-there',
                disallowClose: true,
                autoClose: 5000,
                title: "Please Select Date.",
                color: 'red',
                icon: <IconX size="1rem" />,
                style: { backgroundColor: 'white' },
            });
            return;
        }
        if (emails.length === 0) {
            showNotification({
                id: 'bulk-hello-there',
                disallowClose: true,
                autoClose: 5000,
                title: "Please enter at least one student email",
                color: 'red',
                icon: <IconX size="1rem" />,
                style: { backgroundColor: 'white' },
            });
            return;
        }

        const formattedDate = selectedDate.format('YYYY-MM-DD HH:mm');
        setIsLoading(true);
        setResult(null);

        showNotification({
            id: 'bulk-load-data',
            autoClose: false,
            disallowClose: true,
            loading: true,
            title: "Please Wait",
        });

        axios.post(`student/package-bulk-add`, {
            emails,
            subscription_plan_id: subscriptionPlan,
            start_date: formattedDate,
            price: `${price}`,
        }).then(function (response) {
            const data = response?.data?.data || { success: [], failed: [], notFound: [] };
            setResult(data);

            updateNotification({
                id: 'bulk-load-data',
                color: 'teal',
                title: "Success",
                message: `${data.success?.length || 0} student(s) updated`,
                icon: <IconCheck size="1rem" />,
                autoClose: 3000,
            });

            getUserList && getUserList();
        }).catch(function (error) {
            const message = error?.response?.data?.message || "Something went wrong";
            updateNotification({
                id: 'bulk-load-data',
                color: 'red',
                title: message,
                icon: <IconX size="1rem" />,
                autoClose: 5000,
            });
        }).finally(() => {
            setIsLoading(false);
        });
    };

    return (
        <ModalX
            title="Add Package to Multiple Students"
            visible={isBulkModalVisible}
            onCancel={handleCancel}
            footer={null}
            width={700}
        >
            {loading ? (
                <StyledLoad>
                    <Loader size={"sm"} />
                </StyledLoad>
            ) : (
                <Flex
                    id={"bulk-payment-wrap-list"}
                    display={"flex"}
                    direction={"column"}
                    gap={"20px"}
                >
                    <Select
                        label="Subscription Packages"
                        placeholder="Pick one"
                        searchable
                        nothingFound="No options"
                        data={options}
                        value={subscriptionPlan}
                        onChange={setSubscriptionPlan}
                    />

                    <NumberInput
                        decimalSeparator=","
                        thousandsSeparator="."
                        placeholder={"Pick one"}
                        label="Price"
                        value={price}
                        onChange={setPrice}
                        precision={3}
                        step={0.5}
                    />

                    <div>
                        <DateInput
                            valueFormat="DD-MM-YYYY"
                            value={selectedDate}
                            label="Start Date"
                            placeholder="Pick one"
                            mx="auto"
                            clearable={true}
                            onChange={handleDateChange}
                            locale={"tr"}
                        />
                    </div>

                    <Textarea
                        label="Student Emails"
                        description={`Separate emails with a comma (,). ${parseEmails(emailsRaw).length} email(s) entered.`}
                        placeholder="ornek1@mail.com, ornek2@mail.com, ornek3@mail.com"
                        minRows={4}
                        autosize
                        value={emailsRaw}
                        onChange={(e) => setEmailsRaw(e.currentTarget.value)}
                    />

                    {result && (
                        <ResultBox>
                            <p><strong>Success ({result.success?.length || 0}):</strong> {result.success?.join(", ") || "-"}</p>
                            {result.notFound?.length > 0 && (
                                <p className="warn"><strong>Not Found ({result.notFound.length}):</strong> {result.notFound.join(", ")}</p>
                            )}
                            {result.failed?.length > 0 && (
                                <p className="error">
                                    <strong>Failed ({result.failed.length}):</strong>{" "}
                                    {result.failed.map(f => `${f.email} (${f.message})`).join(", ")}
                                </p>
                            )}
                        </ResultBox>
                    )}

                    <Flex display={"flex"} justify={"right"}>
                        <CustomButton
                            text={"Save"}
                            loading={isLoading}
                            onClick={() => handleSaveClick()}
                        />
                    </Flex>
                </Flex>
            )}
        </ModalX>
    );
};

const StyledLoad = styled.div`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
`;

const ResultBox = styled.div`
    background: #fafafa;
    border: 1px solid #eee;
    border-radius: 4px;
    padding: 10px 14px;
    font-size: 13px;

    p {
        margin: 4px 0;
        word-break: break-word;
    }
    .warn {
        color: #d48806;
    }
    .error {
        color: #cf1322;
    }
`;

const ModalX = styled(Modal)`
  .ant-modal-content{
    min-height: 300px;
  }
`;

export default BulkAddPackage;
